import { render, staticRenderFns } from "./CreatShipingIntruction.vue?vue&type=template&id=8e16f7f4"
import script from "./CreatShipingIntruction.vue?vue&type=script&lang=js"
export * from "./CreatShipingIntruction.vue?vue&type=script&lang=js"
import style0 from "./CreatShipingIntruction.vue?vue&type=style&index=0&id=8e16f7f4&prod&lang=css"
import style1 from "./CreatShipingIntruction.vue?vue&type=style&index=1&id=8e16f7f4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports